// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import { Upload } from "lucide-react";

// const BuyerCorporateCreateProfileForm = ({ onSubmit, isLoading, formData }) => {
//   const [eIdFrontImage, seteIdFrontImage] = useState(null);
//   const [eIdBackImage, seteIdBackImage] = useState(null);
//   const [tradeLicense, setTradeLicense] = useState(null);
//   const [trnCertificate, setTrnCertificate] = useState(null);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();

//   const handleFileChange = (setFile) => (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 5 * 1024 * 1024) {
//         showError("File size should be less than 5MB");
//         return;
//       }
//       setFile(file);
//     }
//   };

//   const handleFormSubmit = (data) => {
//     onSubmit({
//       ...data,
//       eIdFrontImage,
//       eIdBackImage,
//       tradeLicense,
//       trnCertificate,
//     });
//   };

//   return (
//     <form onSubmit={handleSubmit(handleFormSubmit)} className="w-full h-full">
//       <div className="space-y-3">
//         <h3 className="text-2xl capitalize md:text-[28px] font-bold mb-1 text-[#131313] text-center">
//           Complete Your Profile
//         </h3>
//         <p className="text-[#13131399] capitalize pb-10 text-sm md:text-[16px] text-center">
//           Please provide additional details for your corporate account
//         </p>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         {/* Company Name */}
//         <div className="mb-4">
//           <label className="block text-sm md:text-[16px] font-medium text-[#131313] mb-2">
//             Business Name
//           </label>
//           <input
//             type="text"
//             placeholder="Enter Business name"
//             className={`w-full pl-4 pr-4 py-3 border ${
//               errors.businessName ? "border-red-500" : "border-[#13131399]"
//             } rounded-lg bg-white focus:outline-none`}
//             {...register("businessName", {
//               // required: "Company name is required",
//             })}
//           />
//           {/* {errors.companyName && (
//             <p className="mt-1 text-sm text-red-500">
//               {errors.companyName.message}
//             </p>
//           )} */}
//         </div>

//         {/* Trade businessRegistration No Number */}
//         <div className="mb-4">
//           <label className="block text-sm md:text-[16px] font-medium text-[#131313] mb-2">
//             Business Reg No.
//           </label>
//           <input
//             type="text"
//             placeholder="Enter license number"
//             className={`w-full pl-4 pr-4 py-3 border ${
//               errors.businessRegNo ? "border-red-500" : "border-[#13131399]"
//             } rounded-lg bg-white focus:outline-none`}
//             {...register("businessRegNo", {
//               // required: "License number is required",
//             })}
//           />
//           {/* {errors.businessRegNo && (
//             <p className="mt-1 text-sm text-red-500">
//               {errors.businessRegNo.message}
//             </p>
//           )} */}
//         </div>

//         {/* Emirates ID Front */}
//         <div className="mb-4">
//           <label className="block text-sm md:text-[16px] font-medium text-[#131313] mb-2">
//             Emirates ID Front
//           </label>
//           <div className="border-2 border-dashed bg-white border-gray-500 rounded-lg p-4 text-center">
//             <input
//               type="file"
//               id="eIdFrontImage"
//               accept=".jpeg,.jpg,.png,.pdf"
//               onChange={handleFileChange(seteIdFrontImage)}
//               className="hidden"
//             />
//             <label
//               htmlFor="eIdFrontImage"
//               className="cursor-pointer flex flex-col items-center"
//             >
//               <Upload className="w-6 h-6 text-gray-500 mb-2" />
//               <span className="text-sm text-gray-500">
//                 JPEG, PNG, JPG, and PDF formats, up to 5MB
//               </span>
//               <button
//                 type="button"
//                 className="mt-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-colors"
//               >
//                 Browse File
//               </button>
//               {eIdFrontImage && (
//                 <p className="mt-2 text-sm text-green-600">
//                   {eIdFrontImage.name}
//                 </p>
//               )}
//             </label>
//           </div>
//         </div>

//         {/* Emirates ID Back */}
//         <div className="mb-4">
//           <label className="block text-sm md:text-[16px] font-medium text-[#131313] mb-2">
//             Emirates ID Back
//           </label>
//           <div className="border-2 border-dashed bg-white border-gray-500 rounded-lg p-4 text-center">
//             <input
//               type="file"
//               id="eIdBackImage"
//               accept=".jpeg,.jpg,.png,.pdf"
//               onChange={handleFileChange(seteIdBackImage)}
//               className="hidden"
//             />
//             <label
//               htmlFor="eIdBackImage"
//               className="cursor-pointer flex flex-col items-center"
//             >
//               <Upload className="w-6 h-6 text-gray-500 mb-2" />
//               <span className="text-sm text-gray-500">
//                 JPEG, PNG, JPG, and PDF formats, up to 5MB
//               </span>
//               <button
//                 type="button"
//                 className="mt-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-colors"
//               >
//                 Browse File
//               </button>
//               {eIdBackImage && (
//                 <p className="mt-2 text-sm text-green-600">
//                   {eIdBackImage.name}
//                 </p>
//               )}
//             </label>
//           </div>
//         </div>
//       </div>

//       {/* Submit button */}
//       <button
//         type="submit"
//         disabled={isLoading}
//         className={`w-full border border-[#F15A29] bg-white text-primary-dark py-3 rounded-lg hover:bg-primary-dark hover:text-white transition-all duration-200 font-medium mb-4 ${
//           isLoading ? "opacity-90 cursor-not-allowed" : ""
//         }`}
//       >
//         {isLoading ? "Submitting..." : "Complete Registration"}
//       </button>
//     </form>
//   );
// };

// export default BuyerCorporateCreateProfileForm;
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Upload, ArrowLeft } from "lucide-react";
import { useToast } from "../../context/ToastContext";

const BuyerCorporateCreateProfileForm = ({
  onSubmit,
  isLoading,
  formData,
  onGoBack,
}) => {
  const { showError } = useToast();
  const [eIdFrontImage, seteIdFrontImage] = useState(null);
  const [eIdBackImage, seteIdBackImage] = useState(null);
  const [tradeLicenseImage, setTradeLicenseImage] = useState(null);
  const [trnCertificateImage, setTrnCertificateImage] = useState(null);
  const [fileErrors, setFileErrors] = useState({});

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleFileChange = (setFile, fileType) => (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        showError("File size should be less than 5MB");
        return;
      }
      setFile(file);
      // Clear error for this file type when file is selected
      setFileErrors(prev => ({
        ...prev,
        [fileType]: null
      }));
    }
  };

  const handleFormSubmit = (data) => {
    // Validate required documents (back image is optional)
    const errors = {};
    
    if (!eIdFrontImage) {
      errors.eIdFrontImage = "Emirates ID / Passport / National ID ( Front ) is required";
    }

    if (!tradeLicenseImage) {
      errors.tradeLicenseImage = "Trade License image is required";
    }

    if (!trnCertificateImage) {
      errors.trnCertificateImage = "TRN Certificate image is required";
    }

    if (Object.keys(errors).length > 0) {
      setFileErrors(errors);
      return;
    }

    // Clear any previous errors
    setFileErrors({});

    onSubmit({
      ...data,
      eIdFrontImage,
      eIdBackImage,
      tradeLicenseImage,
      trnCertificateImage,
    });
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className='w-full h-full'>
      {/* Header with back button */}
      <div className='flex items-center mb-6'>
        <button
          type='button'
          onClick={onGoBack}
          className='flex items-center text-gray-600 hover:text-gray-800 transition-colors'
        >
          <ArrowLeft className='w-4 h-4 mr-2' />
          Back
        </button>
      </div>

      <div className='space-y-3'>
        <h3 className='text-2xl capitalize md:text-[28px] font-bold mb-1 text-[#131313] text-center'>
          Complete Your Corporate Buyer Profile
        </h3>
        <p className='text-[#13131399] capitalize pb-6 text-sm md:text-[16px] text-center'>
          Please provide additional details for your corporate Buyer account
        </p>
      </div>

      {/* Business Information Section */}
      <div className='mb-6'>
        <h4 className='text-lg font-semibold text-gray-800 mb-4 border-b pb-2'>
          Business Information
        </h4>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          {/* Business Name */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Business Name <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              placeholder='Enter Business name'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.businessName ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("businessName", {
                required: "Business name is required",
              })}
            />
            {errors.businessName && (
              <p className='mt-1 text-sm text-red-500'>
                {errors.businessName.message}
              </p>
            )}
          </div>

          {/* Business Registration Number */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Business Reg No. <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              placeholder='Enter registration number'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.businessRegNo ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("businessRegNo", {
                required: "Registration number is required",
              })}
            />
            {errors.businessRegNo && (
              <p className='mt-1 text-sm text-red-500'>
                {errors.businessRegNo.message}
              </p>
            )}
          </div>

          {/* Location */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Business Location <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              placeholder='Enter business location'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.location ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("location", {
                required: "Business location is required",
              })}
            />
            {errors.location && (
              <p className='mt-1 text-sm text-red-500'>
                {errors.location.message}
              </p>
            )}
          </div>

          {/* VAT Number */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              VAT Number
            </label>
            <input
              type='text'
              placeholder='Enter VAT number'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.vatNo ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("vatNo")}
            />
          </div>
        </div>
      </div>

      {/* Personal Details Section */}
      <div className='mb-6'>
     

        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          {/* Identification Number */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Emirates ID Number <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              placeholder='Enter Emirates ID number'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.identificationNo
                  ? "border-red-500"
                  : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("identificationNo", {
                required: "Emirates ID number is required",
                pattern: {
                  value: /^[0-9-]+$/,
                  message: "Please enter a valid Emirates ID number",
                },
              })}
            />
            {errors.identificationNo && (
              <p className='mt-1 text-sm text-red-500'>
                {errors.identificationNo.message}
              </p>
            )}
          </div>

          {/* EID Expiry Date */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              EID Expiry Date <span className='text-red-500'>*</span>
            </label>
            <input
              type='date'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.idExprDate ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("idExprDate", {
                required: "EID expiry date is required",
              })}
            />
            {errors.idExprDate && (
              <p className='mt-1 text-sm text-red-500'>
                {errors.idExprDate.message}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Bank Details Section */}
      {/* <div className='mb-6'>
        <h4 className='text-lg font-semibold text-gray-800 mb-4 border-b pb-2'>
          Bank Details
        </h4> */}

        {/* <div className='grid grid-cols-1 md:grid-cols-2 gap-4'> */}
          {/* Bank Name */}
          {/* <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Bank Name
            </label>
            <input
              type='text'
              placeholder='Enter your bank name'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.bankName ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("bankName")}
            />
          </div> */}

          {/* Account Holder Name */}
          {/* <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Account Holder Name
            </label>
            <input
              type='text'
              placeholder='Enter account holder name'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.accountHolderName
                  ? "border-red-500"
                  : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("accountHolderName")}
            />
          </div> */}

          {/* Account Number */}
          {/* <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Account Number
            </label>
            <input
              type='text'
              placeholder='Enter your account number'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.accountNumber ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("accountNumber")}
            />
          </div> */}

          {/* IBAN */}
          {/* <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              IBAN
            </label>
            <input
              type='text'
              placeholder='Enter your IBAN'
              className={`w-full pl-4 pr-4 py-3 border ${
                errors.iban ? "border-red-500" : "border-[#13131399]"
              } rounded-lg bg-white focus:outline-none`}
              {...register("iban")}
            />
          </div>
        </div>
      </div>

      {/* Document Upload Section */}
      <div className='mb-6'>
        <h4 className='text-lg font-semibold text-gray-800 mb-4 border-b pb-2'>
          Required Documents
        </h4>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          {/* Emirates ID / Passport / National ID ( Front ) */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Emirates ID / Passport / National ID ( Front ) <span className='text-red-500'>*</span>
            </label>
            <div className={`border-2 border-dashed bg-white rounded-lg p-4 text-center ${
              fileErrors.eIdFrontImage ? "border-red-500" : "border-gray-500"
            }`}>
              <input
                type='file'
                id='eIdFrontImage'
                accept='.jpeg,.jpg,.png,.pdf'
                onChange={handleFileChange(seteIdFrontImage, "eIdFrontImage")}
                className='hidden'
              />
              <label
                htmlFor='eIdFrontImage'
                className='cursor-pointer flex flex-col items-center'
              >
                <Upload className='w-6 h-6 text-gray-500 mb-2' />
                <span className='text-sm text-gray-500'>
                  JPEG, PNG, JPG, and PDF formats, up to 5MB
                </span>
                <button
                  type='button'
                  onClick={() => document.getElementById("eIdFrontImage").click()}
                  className='mt-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-colors'
                >
                  Browse File
                </button>
                {eIdFrontImage && (
                  <p className='mt-2 text-sm text-green-600'>
                    ✓ {eIdFrontImage.name}
                  </p>
                )}
              </label>
            </div>
            {fileErrors.eIdFrontImage && (
              <p className='mt-1 text-sm text-red-500'>{fileErrors.eIdFrontImage}</p>
            )}
          </div>

          {/* Emirates ID / National ID ( Back ) - Optional */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Emirates ID / National ID ( Back )
            </label>
            <div className={`border-2 border-dashed bg-white rounded-lg p-4 text-center ${
              "border-gray-500"
            }`}>
              <input
                type='file'
                id='eIdBackImage'
                accept='.jpeg,.jpg,.png,.pdf'
                onChange={handleFileChange(seteIdBackImage, "eIdBackImage")}
                className='hidden'
              />
              <label
                htmlFor='eIdBackImage'
                className='cursor-pointer flex flex-col items-center'
              >
                <Upload className='w-6 h-6 text-gray-500 mb-2' />
                <span className='text-sm text-gray-500'>
                  JPEG, PNG, JPG, and PDF formats, up to 5MB
                </span>
                <button
                  type='button'
                  onClick={() => document.getElementById("eIdBackImage").click()}
                  className='mt-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-colors'
                >
                  Browse File
                </button>
                {eIdBackImage && (
                  <p className='mt-2 text-sm text-green-600'>
                    ✓ {eIdBackImage.name}
                  </p>
                )}
              </label>
            </div>
            {/* Back image optional - no required error */}
          </div>

          {/* Trade License Image */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              Trade License Image 
            </label>
            <div className={`border-2 border-dashed bg-white rounded-lg p-4 text-center ${
              fileErrors.tradeLicenseImage ? "border-red-500" : "border-gray-500"
            }`}>
              <input
                type='file'
                id='tradeLicenseImage'
                accept='.jpeg,.jpg,.png,.pdf'
                onChange={handleFileChange(setTradeLicenseImage, "tradeLicenseImage")}
                className='hidden'
              />
              <label
                htmlFor='tradeLicenseImage'
                className='cursor-pointer flex flex-col items-center'
              >
                <Upload className='w-6 h-6 text-gray-500 mb-2' />
                <span className='text-sm text-gray-500'>
                  JPEG, PNG, JPG, and PDF formats, up to 5MB
                </span>
                <button
                  type='button'
                  onClick={() => document.getElementById("tradeLicenseImage").click()}
                  className='mt-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-colors'
                >
                  Browse File
                </button>
                {tradeLicenseImage && (
                  <p className='mt-2 text-sm text-green-600'>
                    ✓ {tradeLicenseImage.name}
                  </p>
                )}
              </label>
            </div>
            {fileErrors.tradeLicenseImage && (
              <p className='mt-1 text-sm text-red-500'>{fileErrors.tradeLicenseImage}</p>
            )}
          </div>

          {/* TRN Certificate Image */}
          <div className='mb-4'>
            <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
              TRN Certificate Image 
            </label>
            <div className={`border-2 border-dashed bg-white rounded-lg p-4 text-center ${
              fileErrors.trnCertificateImage ? "border-red-500" : "border-gray-500"
            }`}>
              <input
                type='file'
                id='trnCertificateImage'
                accept='.jpeg,.jpg,.png,.pdf'
                onChange={handleFileChange(setTrnCertificateImage, "trnCertificateImage")}
                className='hidden'
              />
              <label
                htmlFor='trnCertificateImage'
                className='cursor-pointer flex flex-col items-center'
              >
                <Upload className='w-6 h-6 text-gray-500 mb-2' />
                <span className='text-sm text-gray-500'>
                  JPEG, PNG, JPG, and PDF formats, up to 5MB
                </span>
                <button
                  type='button'
                  onClick={() => document.getElementById("trnCertificateImage").click()}
                  className='mt-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-colors'
                >
                  Browse File
                </button>
                {trnCertificateImage && (
                  <p className='mt-2 text-sm text-green-600'>
                    ✓ {trnCertificateImage.name}
                  </p>
                )}
              </label>
            </div>
            {fileErrors.trnCertificateImage && (
              <p className='mt-1 text-sm text-red-500'>{fileErrors.trnCertificateImage}</p>
            )}
          </div>
        </div>
      </div>

      {/* Submit button */}
      <button
        type='submit'
        disabled={isLoading}
        className={`w-full border border-[#F15A29] bg-white text-[#F15A29] py-3 rounded-lg hover:bg-[#F15A29] hover:text-white transition-all duration-200 font-medium mb-4 ${
          isLoading ? "opacity-90 cursor-not-allowed" : ""
        }`}
      >
        {isLoading ? "Submitting..." : "Complete Corporate Buyer Registration"}
      </button>
    </form>
  );
};

export default BuyerCorporateCreateProfileForm;
